import { RoutesApp } from './routes';
import './styles/main.css';

export const App = () => {
  return (
    <>
      <RoutesApp />
    </>
  );
};
